import type { DeepPartial } from '@luna/utils-ts';

import type { Overview } from '../../types/Overview';

export const overviewCZFeatureConfig: DeepPartial<Overview> = {
    applyPositionsForTitleCount: true,
    getSumPerTypeMarketValue: true,
    showTradingButton: true,
    sortAttribute: '-marketValue',
    stockValueTooltip: true,
    sumValueFromMarketValue: true,
    sumValueFromPerformance: true,
    totalMarketValueFromPositions: true,
};
